import axios from "axios";
import { IPlaylistResponseDto } from "../types";

class PlaylistsService {
    async getAllPlaylists(
        clientId: string,
        limit: number = 5
    ): Promise<IPlaylistResponseDto[]> {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/playList/${clientId}?limit=${limit}`
            );

            return response.data.data.playlistItems;
        } catch (err: any) {
            console.log(
                "There is an error while fetching ad server banners",
                err
            );
            throw new Error(err);
        }
    }

    async getPlaylistById(
        clientId: string,
        playlistId: string
    ): Promise<IPlaylistResponseDto> {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/playList/${clientId}/${playlistId}`
            );

            return response.data.data;
        } catch (err: any) {
            console.log(
                "There is an error while fetching ad server banners",
                err
            );
            throw new Error(err);
        }
    }
}

export const playlistsService = new PlaylistsService();
